import { Module } from 'data/terra/Module';

export const FETCH_MODULES = 'FETCH_MODULES';

export interface FetchModulesResult {
  type: typeof FETCH_MODULES;
  modules: Module[];
}

export const SELECT_MODULE = 'SELECT_MODULE';

export interface SelectModule {
  type: typeof SELECT_MODULE;
  module: Module;
}

export type ModuleAction = FetchModulesResult | SelectModule;
